import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BasketRecommendationsService_GetBasketRecommendationsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/recommendations/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import {useSelectedTargetGroup} from '../../../shared-deprecated/useSelectedTargetGroup';
import {useReductionsStateRequestParameter} from '../../ReductionsState/useReductionsStateRequestParameter';

export const useBasketRecommendations = ({
  requestEnabled = true,
  productId,
}: {
  requestEnabled?: boolean;
  productId: number;
}) => {
  const session = useOptionalSession();
  const {targetGroup} = useSelectedTargetGroup();

  return useGrpcRequest(
    BasketRecommendationsService_GetBasketRecommendationsLazy,
    {
      productId,
      session,
      targetGroup,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {
      disabled: !requestEnabled || !productId,
    },
  );
};
